module.exports = __webpack_public_path__ + "static/tokopedia-d5dacf22a9dcd4ae1a3c34fcb2fcc557.svg";